import { createSelector } from "@reduxjs/toolkit";
import { areConfigurationsEqual } from "../../utilities/configurationComparer";
import type { RootState } from "../types/store.types";
import { selectFieldsStateConfiguration } from "./fieldsStateSelectors";

export const selectInitialConfiguration = (state: RootState) => state.currentReport.report?.configuration;

export const selectIsReportChanged = createSelector(
  selectInitialConfiguration,
  selectFieldsStateConfiguration,
  (initialConfiguration, selectedFieldsConfiguration) => {
    if (!initialConfiguration || !selectedFieldsConfiguration) {
      return false;
    }
    return !areConfigurationsEqual(initialConfiguration, selectedFieldsConfiguration);
  }
);
export const selectRefreshToken = (state: RootState) => state.currentReport.refreshToken;
export const selectSessionId = (state: RootState) => state.currentReport.sessionId;
export const selectCacheSessionId = (state: RootState) => state.currentReport.cacheSessionId;
export const selectCurrentReportId = (state: RootState) => state.currentReport.report?.reportId;
export const selectCurrentReportType = (state: RootState) => state.currentReport.report?.reportType;
export const selectHasCurrentReport = (state: RootState) => state.currentReport.report !== undefined;
export const selectCurrentReportName = (state: RootState) => state.currentReport.report?.name;
export const selectCurrentReportClientCode = (state: RootState) => state.currentReport.report?.clientCode;
export const selectCurrentReport = (state: RootState) => state.currentReport.report;
export const selectIsNewReport = (state: RootState) => state.currentReport.report?.isDraft === true;
export const selectCurrentReportAuthorizationInfo = (state: RootState) => state.currentReport.authorizationInfo;
export const selectPreviewMode = (state: RootState) => state.currentReport.previewMode;
export const selectReportEditMode = (state: RootState) => state.currentReport.editMode;
export const selectAutoShowItemOptionsId = (state: RootState) => state.currentReport.autoShowItemOptionsId;
export const selectResetId = (state: RootState) => state.currentReport.resetSessionId;
export const selectEtag = (state: RootState) => state.currentReport.etag;
export const selectDrillDownCacheValid = (state: RootState) => state.currentReport.cacheValid;
export const selectCurrentBuildProgress = (state: RootState) => state.currentReport.currentBuildProgress;
export const selectIsReportTransactional = (state: RootState) => state.currentReport.transactional;
